import type { ReactNode } from 'react'
import { Plus } from 'lucide-react'
import { DashedButton } from './DashedButton'

// Same dashed "+ label" row the app uses for other inline add actions
// (SocialView's DashedRow, TotemManagePage's add-totem button).
export function SuggestRow({ onClick, label }: { onClick: () => void; label: ReactNode }) {
  return (
    <DashedButton
      onClick={onClick}
      className="flex items-center justify-center gap-2 px-4 py-3 text-sm text-muted-foreground hover:text-foreground"
    >
      <Plus className="size-4" />
      <span>{label}</span>
    </DashedButton>
  )
}
